import React from 'react';
import '../CSS/Footer.css';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer">
    
      <p><a href="mailto:pychunk.gov@gmail.com">{t('email_us')}</a></p>
      <p><a href="/social">{t('social_handles')}</a></p>
      <div className="social-media">
        <a href="https://github.com/ramswarooppatel">{t('github')}</a> |
        <a href="https://linkedin.com/in/ramswarooppatel">{t('linkedin')}</a> |
        <a href="https://twitter.com/rsp.og">{t('twitter')}</a> |
        <a href="https://instagram.com/ramswaroop03">{t('instagram')}</a>
      </div>
      <p>&copy; 2026 <strong>PYCHUNK</strong>. {t('all_rights_reserved')}</p>
      <br />
      <br />
      <br />
    </footer>
  );
};

export default Footer;